import React from 'react';
import cx from 'classnames';

// Icon
import ALERT_ICON from 'material-design-icons/alert/svg/production/ic_error_outline_24px.svg';
import WARNING from '@arrive/ui-icons/svg/ic_warning.svg';

import SVGIcon from '@arrive/svg-icon';
import Button from '@arrive/button';

// Styles
import styles from './ErrorBar.scss';

export interface Props {
  classes?: {
    container?: string;
    errorItem?: string;
    svgItem?: string;
  };
  errorMessage: React.ReactNode;
  onRetry?: () => void;
  styles?: {
    container?: { [key: string]: string };
    errorItem?: { [key: string]: string };
    svgItem?: { [key: string]: string };
  };
  type?: 'error' | 'warning'
}

export default function ErrorBar({ classes = {}, errorMessage, onRetry, type = 'error' }: Props) {
  return (
    <div className={cx(styles.container, classes.container, { [styles.warning]: type === 'warning' })}>
      <span
        className={cx(styles.errorItem, classes.errorItem)}
      >
        {type === 'error' && <SVGIcon className={cx(styles.errorItemSvg, classes.svgItem)} svgRef={ALERT_ICON} />}
        {type === 'warning' && <SVGIcon className={cx(styles.warningIcon, classes.svgItem)} svgRef={WARNING} />}
        {errorMessage}
        {onRetry && <Button className={styles.errorItemButton} onClick={onRetry} text>click to retry</Button>}
      </span>
    </div>
  );
}
